<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>
    <span *ngIf="data.coverage_title === coverageIdEnum.InboedelStandaard">Inboedel</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.OpstalStandaard">Opstal</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Glas">Glas</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.MobieleElektronica">Mobiele Elektronica</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.EigenaarsHuurderbelang">Eigenaars/ huurdersbelang</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Aansprakelijkheidsverzekering">Aansprakelijkheid</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Compleet">Compleet</span>
</h2>
<div modal-content>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.InboedelStandaard">
        <ins-inboedel-info></ins-inboedel-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.OpstalStandaard">
        <ins-opstal-info></ins-opstal-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.Glas">
        <ins-glas-info></ins-glas-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.MobieleElektronica">
        <ins-mobiele-elektronica-info></ins-mobiele-elektronica-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.EigenaarsHuurderbelang">
        <ins-eigenaars-huurderbelang-info></ins-eigenaars-huurderbelang-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.Aansprakelijkheidsverzekering">
        <ins-aansprakelijkheid-info></ins-aansprakelijkheid-info>
    </ng-container>
    <ng-container *ngIf="data.coverage_id === coverageIdEnum.Compleet">
        <ins-compleet-info></ins-compleet-info>
    </ng-container>
</div>
<div modal-actions alignment="end">
    <a href="#" title="Sluit" class="modal__close-bottom link-secondary" (click)="close()">
        <span>Sluit</span>
        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
    </a>
</div>
